import { IPasswordPolicy } from './IPasswordPolicy';

export class MinimumPasswordLengthPolicy implements IPasswordPolicy {

    private minLength: number;

    public constructor(minLength: number) {
        this.minLength = minLength;
    }

    public isValid(password: string): boolean {
        return password && password.length >= this.minLength;
    }
}
